module.exports = "<div class=\"page-container\" fxLayout=\"column\">\n\n  <div class=\"cerba-content\" fxLayout=\"column\" fxFlex=\"1 0 auto\">\n    <div class=\"brushHeader\">\n      <span><img src=\"./assets/images/brush-title.svg\" ></span>\n      <h1 class=\"cerba-h1\" translate=\"TITLES.Paiement_en_ligne\"></h1>\n\n    </div>\n\n    <cm-header></cm-header>\n    <router-outlet></router-outlet>\n</div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/cerba.component.html
// module id = ../../../../../src/app/pages/cerba/cerba.component.html
// module chunks = 1